module.exports = __webpack_public_path__ + "static/Principal-Regular-e734137f219b3397f15201c9b3305bb4.woff";